import { ColumnDefinition } from "../Grid/Columns";
import { getDefaultMarketColumns } from "../Markets/MarketsGrid";
import { Account, TradingAccount, Currency } from "swan-public-api-client";

const settingsSaveMarketsGridAction = "SETTINGS_SAVE_MARKETS_GRID";
const settingsSaveColoursAction = "SETTINGS_SAVE_COLOURS";

const saveClientAccountAction = "SAVE_CLIENT_ACCOUNT"
const saveActiveTradingAccountAction = "SAVE_ACTIVE_TRADING_ACCOUNT";
const saveTradingAccountsAction = "SAVE_TRADING_ACCOUNTS";
const saveCurrenciesAction = "SAVE_CURRENCIES";
const saveLinkedTradingAccountsAction = "SAVE_LINKED_TRADING_ACCOUNTS";

export interface ClientAccount {
  account?: Account;
}

export interface ActiveTradingAccount {
  account?: TradingAccount;
}

export interface SettingsMarketsGrid {
  columns: ColumnDefinition[];
}

export interface SettingsColours {
  "@primary-color"?: string;
}

interface SettingsSaveMarketsGridAction {
  type: typeof settingsSaveMarketsGridAction;
  settings: SettingsMarketsGrid;
}

interface SettingsSaveColoursAction {
  type: typeof settingsSaveColoursAction;
  settings: SettingsColours;
}

interface SaveClientAccountAction {
  type: typeof saveClientAccountAction;
  account: Account;
}

interface SaveActiveTradingAccountAction {
  type: typeof saveActiveTradingAccountAction;
  account: TradingAccount | undefined;
}

interface SaveTradingAccountsAction {
  type: typeof saveTradingAccountsAction;
  tradingAccounts: TradingAccount[];
}

interface SaveLinkedTradingAccountsAction {
  type: typeof saveLinkedTradingAccountsAction;
  linkedTradingAccounts: TradingAccount[];
}

interface SaveCurrenciesAction {
  type: typeof saveCurrenciesAction;
  currencies: Currency[];
}

export const settingsMarketsGrid = (
  state: SettingsMarketsGrid = { columns: getDefaultMarketColumns() },
  action: SettingsSaveMarketsGridAction
): SettingsMarketsGrid => {
  switch (action.type) {
    case settingsSaveMarketsGridAction:
      return {
        columns: action.settings.columns
      };
    default:
      return state;
  }
};

export const settingsColours = (
  state: SettingsColours = { },
  action: SettingsSaveColoursAction
): SettingsColours => {
  switch (action.type) {
    case settingsSaveColoursAction:
      return { ...action.settings };
    default:
      return state;
  }
};

export const settingsSaveMarketsGrid = (settings: SettingsMarketsGrid): SettingsSaveMarketsGridAction => ({
  settings,
  type: settingsSaveMarketsGridAction
});

export const settingsSaveColours = (settings: SettingsColours): SettingsSaveColoursAction => ({
  settings,
  type: settingsSaveColoursAction
});

export const clientAccount = (
  state: ClientAccount = {},
  action: SaveClientAccountAction
): ClientAccount => {
  switch (action.type) {
    case saveClientAccountAction:
      return { account: action.account };
    default:
      return state;
  }
};

export const activeTradingAccount = (
  state: ActiveTradingAccount = {},
  action: SaveActiveTradingAccountAction
): ActiveTradingAccount => {
  switch (action.type) {
    case saveActiveTradingAccountAction:
      return { account: action.account !== undefined ? { ...action.account } : undefined };
    default:
      return state;
  }
};

export const tradingAccounts = (
  state: TradingAccount[] = [],
  action: SaveTradingAccountsAction
): TradingAccount[] => {
  switch (action.type) {
    case saveTradingAccountsAction:
      return [...action.tradingAccounts];
    default:
      return state;
  }
};

export const linkedTradingAccounts = (
  state: TradingAccount[] = [],
  action: SaveLinkedTradingAccountsAction
): TradingAccount[] => {
  switch (action.type) {
    case saveLinkedTradingAccountsAction:
      return [...action.linkedTradingAccounts];
    default:
      return state;
  }
}

export const currencies = (
  state: Currency[] = [],
  action: SaveCurrenciesAction
): Currency[] => {
  switch (action.type) {
    case saveCurrenciesAction:
      return [...action.currencies];
    default:
      return state;
  }
};

export const saveClientAccount = (
  account: Account
): SaveClientAccountAction => ({
  account,
  type: saveClientAccountAction
});

export const saveActiveTradingAccount = (
  tradingAccount: TradingAccount | undefined
): SaveActiveTradingAccountAction => ({
  account: tradingAccount,
  type: saveActiveTradingAccountAction
});

export const saveTradingAccounts = (
  tas: TradingAccount[]
): SaveTradingAccountsAction => ({
  tradingAccounts: tas,
  type: saveTradingAccountsAction
});

export const saveLinkedTradingAccounts = (
  linkedTradingAccounts: TradingAccount[]
): SaveLinkedTradingAccountsAction => ({
  linkedTradingAccounts,
  type: saveLinkedTradingAccountsAction
});
